export interface ConnectionInfo {
    effectiveType?: string;
    type?: string;
    downlink?: number;
    downlinkMax?: number;
    rtt?: number;
    saveData?: boolean;
}

export const getConnectionInfo = (): ConnectionInfo => {
    const nav = navigator as any;

    if ((navigator as any).connection) {
        return {
            effectiveType: nav.connection.effectiveType,
            type: nav.connection.type,
            downlink: nav.connection.downlink,
            downlinkMax: nav.connection.downlinkMax,
            rtt: nav.connection.rtt,
            saveData: nav.connection.saveData
        };
    }
    return {};
}
